<ol class="demand-activity-log list-unstyled m-0 d-flex flex-column">
  @for (event of events(); track trackEvent($index, event)) {
    <li class="demand-activity-log__row">
      <div class="demand-activity-log__marker" aria-hidden="true">
        @if (event.icon) {
          <span class="demand-activity-log__icon">
            <mat-icon>{{ event.icon }}</mat-icon>
          </span>
        } @else {
          <av-avatar size="sm" [name]="event.avatarName"></av-avatar>
        }
      </div>
      <div class="demand-activity-log__body d-flex flex-column min-width-0 pb-3">
        <span class="demand-activity-log__text">
          @if (event.onBehalfOf; as onBehalfOf) {
            {{
              event.messageKey
                | translate
                  : {
                      actor: (
                        'app.catalog.demand.onBehalfOf'
                          | translate
                            : {
                                delegate: onBehalfOf.delegate | translate,
                                delegator: onBehalfOf.delegator | translate,
                              }
                      ),
                      step: event.step,
                    }
            }}
          } @else {
            {{
              event.messageKey
                | translate
                  : {
                      actor: event.actorName | translate,
                      step: event.step,
                    }
            }}
          }
        </span>
        <span
          class="text-muted small demand-activity-log__time"
          [matTooltip]="event.timestamp | date: 'dd/MM/yyyy HH:mm'"
        >
          @if (event.showAbsoluteDate) {
            {{ event.timestamp | date: 'dd/MM/yyyy' }}
          } @else {
            {{ event.relativeKey | translate: event.relativeValue }}
          }
        </span>
      </div>
    </li>
  }
</ol>
